export const SHOP_DATA_TABS_GENERAL_KEY = '0';

export const VACANCY_TYPE = {
  PERCENTAGE: 'percentage',
  UNIT: 'unit',
};

export const ACCOMMODATION_FIELDS = {
  UNIT: 'unit_type',
  BASE_RENT: 'base_rent',
  ENTRANCE_FEE: 'entrance_fee',
  SQUARE_FOOTAGE: 'sq_footage',
  NOTES: 'notes',
};

export const FEES_FIELDS = {
  ADDITIONAL_FEE: 'additional_fee',
  DEPOSIT: 'deposit',
  EMERGENCY_PENDANT_FEE: 'emergency_pendant_fee',
  MOVE_IN_FEE: 'move_in_fee',
  PARKING_FEE: 'parking_fee',
  PET_FEE: 'pet_fee',
  RESPITE_FEE: 'respite_fee',
  SECOND_PERSON_FEE: 'second_person_fee',
  SECOND_PERSON_ENTRANCE_FEE: 'second_person_entrance_fee',
};

export const DEFAULT_FEES_FIELDS = [
  FEES_FIELDS.DEPOSIT,
  FEES_FIELDS.MOVE_IN_FEE,
  FEES_FIELDS.PET_FEE,
  FEES_FIELDS.RESPITE_FEE,
  FEES_FIELDS.SECOND_PERSON_FEE,
];

export const SHOP_NOTES_FIELD = 'shop_notes';
export const DOCUMENTS_FIELD = 'documents';

export const FEES_FIELDS_LEVELS = 'levels';
export const FEES_LEVELS_FIELDS = {
  LEVEL_1: 'level_1',
  LEVEL_2: 'level_2',
  LEVEL_3: 'level_3',
  LEVEL_4: 'level_4',
  LEVEL_5: 'level_5',
  LEVEL_6: 'level_6',
  LEVEL_7: 'level_7',
  LEVEL_8: 'level_8',
};

export const LEVEL_FEES_FIELDS = {
  FEES_PRICING_TYPE: 'pricing_type_id',
  AVERAGE_COST: 'average_cost',
  FEE_NOTE: 'fee_note',
  ...FEES_LEVELS_FIELDS,
};

export const FEES_FIELD_COMMUNITY_FEE = 'community_fee';
export const FEES_FIELD_COMMUNITY_FEE_EQUIVALENT = 'community_fee_equivalent';
export const FEES_FIELD_FREQUENCY = 'frequency';
export const FEES_FIELD_FREQUENCY_PERCENTAGE = 'frequency_percentage';
export const FEES_FIELD_COMMUNITY_FEE_EQUIVALENT_ENABLED = 'enable_community_fee_equivalent';
export const FEES_FIELDS_KEYS = Object.values(FEES_FIELDS);
export const FEES_LEVELS_FIELDS_KEYS = Object.values(FEES_LEVELS_FIELDS);

export const SHOP_NOTES_FIELDS_LABELS = {
  [SHOP_NOTES_FIELD]: 'Shop Notes',
};

export const DOCUMENTS_FIELDS_LABEL = 'Brochures & Documents';

export const FEES_FIELDS_LABELS = {
  [FEES_FIELD_COMMUNITY_FEE]: 'Community Fee',
  [FEES_FIELDS.ADDITIONAL_FEE]: 'Additional Fee',
  [FEES_FIELDS.DEPOSIT]: 'Deposit',
  [FEES_FIELD_FREQUENCY]: 'Frequency',
  [FEES_FIELDS.EMERGENCY_PENDANT_FEE]: 'Emergency Pendant Fee',
  [FEES_FIELDS.MOVE_IN_FEE]: 'Move In Fee',
  [FEES_FIELDS.PARKING_FEE]: 'Parking Fee',
  [FEES_FIELDS.PET_FEE]: 'Pet Fee',
  [FEES_FIELDS.RESPITE_FEE]: 'Respite Fee',
  [FEES_FIELDS.SECOND_PERSON_FEE]: 'Second Person Mth. Fee',
  [FEES_FIELDS.SECOND_PERSON_ENTRANCE_FEE]: 'Second Person Ent. Fee',
};

export const LEVEL_FEES_FIELDS_LABELS = {
  [LEVEL_FEES_FIELDS.AVERAGE_COST]: 'Average',
  [LEVEL_FEES_FIELDS.FEES_PRICING_TYPE]: 'Fee Type',
  [LEVEL_FEES_FIELDS.LEVEL_1]: 'Level 1',
  [LEVEL_FEES_FIELDS.LEVEL_2]: 'Level 2',
  [LEVEL_FEES_FIELDS.LEVEL_3]: 'Level 3',
  [LEVEL_FEES_FIELDS.LEVEL_4]: 'Level 4',
  [LEVEL_FEES_FIELDS.LEVEL_5]: 'Level 5',
  [LEVEL_FEES_FIELDS.LEVEL_6]: 'Level 6',
  [LEVEL_FEES_FIELDS.LEVEL_7]: 'Level 7',
  [LEVEL_FEES_FIELDS.LEVEL_8]: 'Level 8',
};

export const FIELD_CATEGORY = {
  ACCOMMODATIONS: 'accommodations',
  FEES_INCENTIVES: 'feesIncentives',
  FEES: 'fees',
  OCCUPANCIES: 'occupancies',
  OCCUPANCIES_OVERALL: 'occupanciesOverall',
  DOCUMENTS: 'documents',
  SHOP_NOTES: 'shopNotes',
  CONTRACT_BENEFITS: 'contractBenefits',
  CONTRACT_BENEFIT_CATEGORIES: 'contractBenefitCategories',
};

export const FIELD_LABELS = {
  [FIELD_CATEGORY.FEES_INCENTIVES]: FEES_FIELDS_LABELS,
  [FIELD_CATEGORY.FEES]: LEVEL_FEES_FIELDS_LABELS,
  [FIELD_CATEGORY.SHOP_NOTES]: SHOP_NOTES_FIELDS_LABELS,
};

export const SAVE_PROMPT_ACTIONS = {
  SAVE: 'save',
  DISCARD: 'discard',
};

export const OCCUPANCIES_MODE = {
  CARE_TYPE: 'care_type',
  ROOM_TYPE: 'room_type',
};

export const INITIAL_SNAPSHOT_DATA_STATUS = {
  accommodations: { dirty: false },
  fees: { dirty: false },
  careFees: { dirty: false },
  occupancies: { dirty: false },
  occupanciesOverall: { dirty: false },
  documents: { dirty: false },
  shopNotes: { dirty: false },
  contractBenefits: { dirty: false },
};

export const RESPITE_FEE_MAX_VALUE = 999;
